module.exports = __webpack_public_path__ + "media/images/photography/students-82919005b63cc28a47ee171f1fe042a6.jpg";